import axios from "axios";

export const authenticate = async (username, password) => {
  const params = new URLSearchParams();
  params.append("grant_type", "password");
  params.append("client_id", "react-fe");
  params.append("username", username);
  params.append("password", password);
  try {
    const data = await axios.post(process.env.REACT_APP_KEYCLOAK_URL, params, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    console.log(data);

    return data?.data;
  } catch (error) {
    console.error("Authentication error:", error);
    throw error;
  }
};

export const getEmbedToken = async (accessToken) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/get-embed-token`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    return response.data.embedToken;
  } catch (error) {
    console.error(
      "Error fetching Keycloak token:",
      error.response?.data || error.message
    );
  }
};
